module.exports = __webpack_public_path__ + "static/media/beesBox.3b2c6769.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/beesBox.jpg
// module id = 146
// module chunks = 0